// extracted by mini-css-extract-plugin
export default {"common_bttn":"button_common_bttn__QcdAS","common_bttn_p":"button_common_bttn_p__dcmai"};